/**
 * Mock Documents for Seed Clients
 * TASK-210: Mock document uploads for prototype demonstration
 *
 * These documents only appear for seed clients (CUST-001, CUST-002, CUST-003)
 * Real API clients will show their actual documents from the backend
 */

export interface MockUpload {
  upload_id: string;
  filename: string;
  file_size: number;
  file_type: string;
  template_type: string;
  upload_status: string;
  total_rows: number | null;
  processed_rows: number | null;
  error_message: string | null;
  created_at: string | null;
  updated_at: string | null;
}

// ============================================================================
// JOHANN MUELLER DOCUMENTS (CUST-001-ABC123)
// ============================================================================

const JOHANN_MUELLER_DOCUMENTS: MockUpload[] = [
  {
    upload_id: 'MOCK-DOC-JM-001',
    filename: 'passport_johann_mueller.pdf',
    file_size: 2456789,
    file_type: 'application/pdf',
    template_type: 'identity_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-06-02T10:15:00Z',
    updated_at: '2024-06-02T10:16:23Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-002',
    filename: 'utility_bill_zurich_2024.pdf',
    file_size: 892345,
    file_type: 'application/pdf',
    template_type: 'proof_of_address',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-06-02T10:18:00Z',
    updated_at: '2024-06-02T10:18:45Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-003',
    filename: 'ubs_account_statement_2024Q2.pdf',
    file_size: 3456789,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-07-15T14:30:00Z',
    updated_at: '2024-07-15T14:32:15Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-004',
    filename: 'ubs_account_statement_2024Q3.pdf',
    file_size: 3512345,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-05T14:20:00Z',
    updated_at: '2024-10-05T14:21:45Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-005',
    filename: 'credit_suisse_pension_statement_2024Q3.pdf',
    file_size: 2678901,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-08T09:45:00Z',
    updated_at: '2024-10-08T09:47:20Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-006',
    filename: 'property_deed_seefeld_apartment.pdf',
    file_size: 4567890,
    file_type: 'application/pdf',
    template_type: 'property_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-09-12T11:00:00Z',
    updated_at: '2024-09-12T11:02:30Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-007',
    filename: 'property_valuation_report_2024.pdf',
    file_size: 1876543,
    file_type: 'application/pdf',
    template_type: 'valuation_report',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-11-20T13:15:00Z',
    updated_at: '2024-11-20T13:16:45Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-008',
    filename: 'picasso_authentication_certificate.pdf',
    file_size: 987654,
    file_type: 'application/pdf',
    template_type: 'art_certificate',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2025-01-05T11:30:00Z',
    updated_at: '2025-01-05T11:31:20Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-009',
    filename: 'tax_return_2023.pdf',
    file_size: 2345678,
    file_type: 'application/pdf',
    template_type: 'tax_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-06-10T15:00:00Z',
    updated_at: '2024-06-10T15:02:10Z'
  },
  {
    upload_id: 'MOCK-DOC-JM-010',
    filename: 'pension_documentation_roche.pdf',
    file_size: 3123456,
    file_type: 'application/pdf',
    template_type: 'pension_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-06-05T10:30:00Z',
    updated_at: '2024-06-05T10:32:45Z'
  }
];

// ============================================================================
// MARIA SCHMIDT DOCUMENTS (CUST-002-DEF456)
// ============================================================================

const MARIA_SCHMIDT_DOCUMENTS: MockUpload[] = [
  {
    upload_id: 'MOCK-DOC-MS-001',
    filename: 'passport_maria_schmidt.pdf',
    file_size: 2234567,
    file_type: 'application/pdf',
    template_type: 'identity_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-04-22T11:30:00Z',
    updated_at: '2024-04-22T11:31:15Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-002',
    filename: 'bank_statement_proof_of_address.pdf',
    file_size: 756432,
    file_type: 'application/pdf',
    template_type: 'proof_of_address',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-04-22T11:35:00Z',
    updated_at: '2024-04-22T11:36:20Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-003',
    filename: 'dataflow_analytics_sale_agreement.pdf',
    file_size: 5678901,
    file_type: 'application/pdf',
    template_type: 'business_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-05-02T14:00:00Z',
    updated_at: '2024-05-02T14:03:45Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-004',
    filename: 'julius_baer_statement_2024Q2.pdf',
    file_size: 3876543,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-07-15T09:45:00Z',
    updated_at: '2024-07-15T09:46:30Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-005',
    filename: 'julius_baer_statement_2024Q3.pdf',
    file_size: 3923456,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-10T10:15:00Z',
    updated_at: '2024-10-10T10:17:05Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-006',
    filename: 'penthouse_purchase_contract.pdf',
    file_size: 4234567,
    file_type: 'application/pdf',
    template_type: 'property_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-07-05T16:00:00Z',
    updated_at: '2024-07-05T16:02:30Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-007',
    filename: 'nextgen_ai_company_registration.pdf',
    file_size: 1567890,
    file_type: 'application/pdf',
    template_type: 'business_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-05-15T12:30:00Z',
    updated_at: '2024-05-15T12:31:45Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-008',
    filename: 'tax_return_2023.pdf',
    file_size: 2567890,
    file_type: 'application/pdf',
    template_type: 'tax_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-05-20T14:00:00Z',
    updated_at: '2024-05-20T14:02:15Z'
  },
  {
    upload_id: 'MOCK-DOC-MS-009',
    filename: 'sustainable_portfolio_prospectus.pdf',
    file_size: 1876543,
    file_type: 'application/pdf',
    template_type: 'investment_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-12-20T09:20:00Z',
    updated_at: '2024-12-20T09:21:35Z'
  }
];

// ============================================================================
// ACME CORPORATION DOCUMENTS (CUST-003-GHI789)
// ============================================================================

const ACME_CORPORATION_DOCUMENTS: MockUpload[] = [
  {
    upload_id: 'MOCK-DOC-AC-001',
    filename: 'commercial_register_extract.pdf',
    file_size: 1234567,
    file_type: 'application/pdf',
    template_type: 'corporate_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-02-16T10:00:00Z',
    updated_at: '2024-02-16T10:02:15Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-002',
    filename: 'company_statutes_2024.pdf',
    file_size: 2345678,
    file_type: 'application/pdf',
    template_type: 'corporate_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-02-16T10:05:00Z',
    updated_at: '2024-02-16T10:07:30Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-003',
    filename: 'board_resolution_investment_policy.pdf',
    file_size: 987654,
    file_type: 'application/pdf',
    template_type: 'corporate_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-03-20T14:30:00Z',
    updated_at: '2024-03-20T14:31:45Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-004',
    filename: 'pictet_operating_account_2024Q2.pdf',
    file_size: 4567890,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-07-20T11:00:00Z',
    updated_at: '2024-07-20T11:02:45Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-005',
    filename: 'pictet_operating_account_2024Q3.pdf',
    file_size: 4623456,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-15T09:30:00Z',
    updated_at: '2024-10-15T09:33:20Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-006',
    filename: 'pictet_operating_account_2024Q4.pdf',
    file_size: 4678901,
    file_type: 'application/pdf',
    template_type: 'bank_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2025-01-08T15:45:00Z',
    updated_at: '2025-01-08T15:47:20Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-007',
    filename: 'openwealth_growth_portfolio_2024Q3.pdf',
    file_size: 3876543,
    file_type: 'application/pdf',
    template_type: 'investment_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-12T10:00:00Z',
    updated_at: '2024-10-12T10:02:15Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-008',
    filename: 'annual_financial_statements_2023.pdf',
    file_size: 6789012,
    file_type: 'application/pdf',
    template_type: 'financial_statement',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-03-31T16:00:00Z',
    updated_at: '2024-03-31T16:05:30Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-009',
    filename: 'tax_return_corporate_2023.pdf',
    file_size: 3456789,
    file_type: 'application/pdf',
    template_type: 'tax_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-04-15T13:30:00Z',
    updated_at: '2024-04-15T13:33:45Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-010',
    filename: 'facility_expansion_contract_germany.pdf',
    file_size: 5234567,
    file_type: 'application/pdf',
    template_type: 'business_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-10-20T14:00:00Z',
    updated_at: '2024-10-20T14:03:15Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-011',
    filename: 'acquisition_contract_competitor_2024.pdf',
    file_size: 4567890,
    file_type: 'application/pdf',
    template_type: 'business_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-06-05T15:30:00Z',
    updated_at: '2024-06-05T15:35:20Z'
  },
  {
    upload_id: 'MOCK-DOC-AC-012',
    filename: 'bond_issuance_prospectus_2024.pdf',
    file_size: 3987654,
    file_type: 'application/pdf',
    template_type: 'financial_document',
    upload_status: 'completed',
    total_rows: null,
    processed_rows: null,
    error_message: null,
    created_at: '2024-01-25T10:00:00Z',
    updated_at: '2024-01-25T10:04:30Z'
  }
];

// ============================================================================
// DOCUMENT REGISTRY
// ============================================================================

export const MOCK_DOCUMENTS: Record<string, MockUpload[]> = {
  'CUST-001-ABC123': JOHANN_MUELLER_DOCUMENTS,
  'CUST-002-DEF456': MARIA_SCHMIDT_DOCUMENTS,
  'CUST-003-GHI789': ACME_CORPORATION_DOCUMENTS
};

/**
 * Get mock documents for a specific client
 * Returns empty array if client is not a seed client
 */
export function getMockDocuments(clientId: string): MockUpload[] {
  return MOCK_DOCUMENTS[clientId] || [];
}

/**
 * Check if a client has mock documents
 */
export function hasMockDocuments(clientId: string): boolean {
  return clientId in MOCK_DOCUMENTS;
}

export default {
  MOCK_DOCUMENTS,
  getMockDocuments,
  hasMockDocuments
};
